import { type DocumentNode, gql } from '@apollo/client';

const createCollectionList: DocumentNode = gql`
  mutation createCollection($asset_ids: [ID]!, $collection_type: String!, $name: String!) {
    createCollection(assetIds: $asset_ids, collectionType: $collection_type, name: $name) {
      __typename
      collection {
        id
        name
        collectionType
        items {
          edges {
            node {
              sequence
              contentObject {
                ... on AssetNodeType {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default createCollectionList;
